import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  CategoryScale,
  LinearScale,
  Tooltip,
} from "chart.js";

import { Line } from "react-chartjs-2";

ChartJS.register(LineElement, PointElement, CategoryScale, LinearScale);

export function ActivityChart({ data }) {
  const chartData = {
    labels: data?.map((item) => item?.month) || [],
    datasets: [
      {
        data: data?.map((item) => item?.totalBookings) || [],
        borderColor: "#2563eb",
        backgroundColor: "#2563eb",
        tension: 0.4, // smooth curve
        pointRadius: 4,
        pointBackgroundColor: "#2563eb",
        fill: false,
      },
    ],
  };

  const options = {
    plugins: { legend: { display: false } },
    scales: {
      x: { grid: { display: false } },
      y: { grid: { display: false } },
    },
  };

  return <Line data={chartData} options={options} />;
}